import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../shared/area-restitra.shared.module';
import { DocumentosService } from '../shared/services/documentos.service';
import { AdministrativoComponent } from './administrativo.component';
import { PautasReunioesComponent } from './pautas-reunioes/pautas-reunioes.component';
import { ProcorManutencaoComunicadoModule } from './procor-manutencao-comunicado/procor-manutencao-comunicado.module';
import { AdministrativoRouterngModule } from './router/administrativo.router';
import { AdministrativoService } from './service/administrativo.service';
import { OperacoesConsultaParticipanteComponent } from './operacoes-consulta-participante/operacoes-consulta-participante.component';
import { EnviarEmailComponent } from './enviar-email/enviar-email.component';
import { PainelControleGerencialComponent } from './painel-controle-gerencial/painel-controle-gerencial.component';
import { PainelAvaliacaoRiscoComponent } from './painel-avaliacao-risco/painel-avaliacao-risco.component';

@NgModule({
  imports: [
      CommonModule,
      AreaRestritaSharedModule,
      AdministrativoRouterngModule,
      ProcorManutencaoComunicadoModule
  ],
  declarations: [
    AdministrativoComponent,
    PautasReunioesComponent,
    OperacoesConsultaParticipanteComponent,
    EnviarEmailComponent,
    PainelControleGerencialComponent,
    PainelAvaliacaoRiscoComponent
  ],
  providers: [
    AdministrativoService,
    DocumentosService
  ]
})
export class AdministrativoModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/administrativo.module.ts